/**
 * Build a filesystem-safe report filename with a `.pdf` extension.
 */
export function buildReportFilename(baseName: string, generatedAt: Date = new Date()): string {
  const safeBase = sanitizeReportFilenamePart(baseName) || 'report';
  const stamp = [
    generatedAt.getFullYear().toString(),
    (generatedAt.getMonth() + 1).toString().padStart(2, '0'),
    generatedAt.getDate().toString().padStart(2, '0'),
    generatedAt.getHours().toString().padStart(2, '0'),
    generatedAt.getMinutes().toString().padStart(2, '0'),
  ].join('');
  return `${safeBase}-${stamp}.pdf`;
}

/**
 * Sanitize a free-text fragment for use in a download filename.
 */
export function sanitizeReportFilenamePart(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}
